import type { PermissionInfo } from '@/domain/entities/permission.entity'
import type { PermissionInfoDto } from './permission.dto'

export const permissionMapper = {
  toPermission(dto: PermissionInfoDto): PermissionInfo {
    return { code: dto.code, description: dto.description ?? '' }
  },
}
